<template>
  <custom-crud-list v-bind="{ ...listConfiguration, ...$attrs }">
    <template #cell-createdAt="{ item }">
      <span>{{ translateDate(item.createdAt, "dateWithTime") }}</span>
    </template>
    <template #cell-updatedAt="{ item }">
      <span>{{ translateDate(item.updatedAt, "dateWithTime") }}</span>
    </template>
    <template #cell-totalWithTax="{ item }">
      <span class="no-word-break">{{
        translateNumber(item.Quote.grandTotal, "currency", {
          from: item.Quote.currency,
        })
      }}</span>
    </template>
    <template #cell-numProducts="{ item }">
      <span>{{ translateNumber(item.Quote.totalProductCount) }}</span>
    </template>
    <template #cell-vendors="{ item }">
      <span v-if="item.Vendors && item.Vendors.length > 0">
        {{ item.Vendors.map((vendor) => vendor.name).join(", ") }}
      </span>
      <span v-else>-</span>
    </template>
    <template #cell-buyer="{ item }">
      <span v-if="item?.Buyer?.email" class="no-word-break">{{ item.Buyer.email }}</span>
      <span v-else>-</span>
    </template>
  </custom-crud-list>

  <order-modal ref="orderViewModal" :order="order" >
    <template #before-table>
      <collapsable-field-set :initially-opened="false" size="s" title="justopp.orders.marketingMaterialsTitle" class="margin-l-top">

        <div class="product-marketing-materials" v-if="order" v-for="item of order?.Quote?.items" >
          <div class="product-images margin-xl-bottom">
            <h4>{{tu('justopp.orders.marketingMaterialsImagesTitle')}}</h4>
            <div class="product-images-inner flex gap-xl flex-wrap  ">
              <div class="image-block flex flex-middle gap-m margin-m-bottom bg-gray-1 border-radius-s padding-s-vertical padding-m-horizontal border-thin-gray" v-for="image of item.cartItem.Product.images">
                <div class="preview background-cover padding-xs"
                     style="height: 80px;width:80px;" :style="`background-image:url('${image.url}');`" ></div>
                <form-button icon="cloud-download"
                             @click="initiateDownload(image.url)"
                             text="justopp.orders.marketingMaterialsDownloadCta"></form-button>
              </div>
            </div>
           </div>
          <div class="product-files">
            <h4>{{tu('justopp.orders.marketingMaterialsFilesTitle')}}</h4>
            <div class="product-files-inner flex gap-l  flex-wrap">
              <div class="file-block flex flex-wrap flex-column width-expand max-width-300 gap-m margin-m-bottom bg-gray-1 border-radius-s padding-s-vertical padding-m-horizontal border-thin-gray"
                   v-if="item.cartItem.Product.specFile && item.cartItem.Product.specFile !='' ">
                <div class="preview background-cover padding-xs">
                  <span class="inline-block text-overflow-ellipsis">{{tu('justopp.orders.marketingSpecFileName')}}</span>
                </div>
                <form-button icon="cloud-download"
                             @click="initiateDownload(item.cartItem.Product.specFile)"
                             text="justopp.orders.marketingMaterialsDownloadCta"></form-button>
              </div>

              <div class="file-block flex flex-wrap  width-expand max-width-300 flex-column gap-m margin-m-bottom bg-gray-1 border-radius-s padding-s-vertical padding-m-horizontal border-thin-gray"
                   v-if="item.cartItem.Product.productFiles && item.cartItem.Product.productFiles.length > 0"
                   v-for="file of item.cartItem.Product.productFiles">
                <div class="preview background-cover padding-xs">
                  <span class="inline-block text-overflow-ellipsis">{{file.fileTitle}}</span>
                </div>
                <form-button icon="cloud-download"
                             @click="initiateDownload(file.fileUrl)"
                             text="justopp.orders.marketingMaterialsDownloadCta"></form-button>
              </div>
            </div>
          </div>

          <div class="product-videos margin-xl-top" v-if="item.cartItem.Product.youtubeVideoId != '' || item.cartItem.Product.videoUrl != ''">
            <h4>{{tu('justopp.orders.marketingMaterialsVideosTitle')}}</h4>
            <div class="youtube-video-link" v-if="item.cartItem.Product.youtubeVideoId != ''">
              <a :href="'https://www.youtube.com/watch?v='+item.cartItem.Product.youtubeVideoId" target="_blank">
                {{tu('justopp.orders.marketingYoutubeVideoCta')}}
              </a>
            </div>
            <div class="youtube-video-link" v-if="item.cartItem.Product.videoUrl != ''">
              <a :href="item.cartItem.Product.videoUrl" target="_blank">
                {{tu('justopp.orders.marketingVideoLinkCta')}}
              </a>
            </div>
          </div>

        </div>

      </collapsable-field-set>
    </template>
  </order-modal>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import useDom from '@/client/extensions/composition/useDom'
import CustomCrudList from "@/client/components/crud/customV1/List.vue";
import { useStore } from "vuex";
import OrderModal from "@/client/components/ecommerce/OrderModal.vue";
import CollapsableFieldSet from '@/client/components/base/frameworks/we/form/CollapsableFieldSet'


export default {
  components: { CollapsableFieldSet, CustomCrudList, OrderModal },
  middleware: {
    requireUser: {},
  },
  props: {
    overrideListConfiguration: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props, useStore());
    let {initiateDownload} = useDom();
    return { asyncOps, asyncOpsReady, asyncStatus,initiateDownload };
  },
  data: function () {
    const userId = this.$store.getters["user/profile"].id;
    return {
      order: false,
      listConfiguration: {
        subject: "order",
        listSrc: "ecommerce/order",
        constantFilters: {
          BuyerId: userId,
        },
        initialOrdering: { key: "createdAt", direction: "desc" },
        showIdField: true, // bool deafult true
        sortable: false, //bool, default false
        publishable: false, //bool, default false
        enableMassActions: false,
        additionalListData: {
          simplified: false,
          translate: false,
        },
        noItemsFoundText: "justopp.orders.noOrders",
        fields: {
          // these are the table columns
          status: {
            itemKey: "status",
            label: "ecommerce.order.fields.status",
            filterable: {
              name: "status",
              type: "select2",
              placeholder: "ecommerce.order.fields.status",
              translateList: true,
              list: [
                { value: "new", label: "ecommerce.order.fields.statuses.new" },
                { value: "canceled", label: "ecommerce.order.fields.statuses.canceled" },
                { value: "payed", label: "ecommerce.order.fields.statuses.payed" },
                { value: "approved", label: "ecommerce.order.fields.statuses.approved" },
                {
                  value: "completed",
                  label: "ecommerce.order.fields.statuses.completed",
                },
              ],
            }, // boolean, or object
            orderable: true,
          },
          createdAt: {
            itemKey: "createdAt",
            label: "ecommerce.order.fields.createdAt",
          },
          totalWithTax: {
            label: "ecommerce.order.fields.totalWithTax",
            orderable: false,
          },
          numProducts: {
            label: "ecommerce.order.fields.numProducts",
            orderable: false,
          },
          vendors: {
            label: "ecommerce.order.fields.vendors",
            orderable: false,
          },
          buyer: {
            label: "ecommerce.order.fields.buyer",
            orderable: false,
          },
          createdFrom: {
            listable: false,
            filterable: {
              name: "createdFrom",
              type: "DatePicker",
              placeholder: "ecommerce.order.fields.createdFrom",
            },
            type: "DatePicker",
            label: "ecommerce.order.fields.createdFrom",
          },
          createdBefore: {
            listable: false,
            filterable: {
              name: "createdBefore",
              type: "DatePicker",
              placeholder: "ecommerce.order.fields.createdBefore",
            },
            label: "ecommerce.order.fields.createdBefore",
          },
          productCodes: {
            label: "ecommerce.order.fields.productCodes",
            listable: false,
            filterable: {
              name: "productCodes",
              placeholder: "ecommerce.order.fields.productCodes",
            },
          },
        },
        actions: {
          show: false,
          edit: false,
          delete: false,
          create: false,
          custom: {
            quickShow: {
              //tooltip
              icon: "eye",
              theme: "inverse",
              //text
              handler: ({ item }) => {
                if (item) {
                  this.showOrder(item);
                }
              },
            },
          },
        },
        ...this.overrideListConfiguration,
      },
    };
  },
  computed: {},
  methods: {
    showOrder(order) {
      this.order = order;
      this.$refs["orderViewModal"].open();
    },
  },
};
</script>

<style scoped lang="scss">
.no-word-break {
  word-break: normal;
}
</style>
